module.exports = __webpack_public_path__ + "static/media/banner-account.cdef0a4f.png";